/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChatMessageInput } from './ChatMessageInput';
import {
    ChatMessageInputFromJSON,
    ChatMessageInputFromJSONTyped,
    ChatMessageInputToJSON,
    ChatMessageInputToJSONTyped,
} from './ChatMessageInput';

/**
 * 
 * @export
 * @interface ChatStreamRequest
 */
export interface ChatStreamRequest {
    /**
     * The current message from the user.
     * @type {string}
     * @memberof ChatStreamRequest
     */
    message: string;
    /**
     * Optional. The history of the conversation.
     * @type {Array<ChatMessageInput>}
     * @memberof ChatStreamRequest
     */
    history?: Array<ChatMessageInput>;
}

/**
 * Check if a given object implements the ChatStreamRequest interface.
 */
export function instanceOfChatStreamRequest(value: object): value is ChatStreamRequest {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function ChatStreamRequestFromJSON(json: any): ChatStreamRequest {
    return ChatStreamRequestFromJSONTyped(json, false);
}

export function ChatStreamRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatStreamRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
        'history': json['history'] == null ? undefined : ((json['history'] as Array<any>).map(ChatMessageInputFromJSON)),
    };
}

export function ChatStreamRequestToJSON(json: any): ChatStreamRequest {
    return ChatStreamRequestToJSONTyped(json, false);
}

export function ChatStreamRequestToJSONTyped(value?: ChatStreamRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'history': value['history'] == null ? undefined : ((value['history'] as Array<any>).map(ChatMessageInputToJSON)),
    };
}

